module.exports = __webpack_public_path__ + "static/media/bronzeTop3D.a0283e61.webp";